
export class BaseMarket {
  constructor() { }

  getFreeCollateral () {
  }
  getPositions () {
  }
  getOrders () {
  }
  getUserTrades () {
  }
  getTrades () {
  }
  getKLine () {
  }
  getMarkets () {

  }
}
